<template>
  <div class="d-flex flex-column justify-content-center align-items-center" style="gap: 5px" v-if="mapsMode && selectedRelease">
    <Generic_LatLong
      :map="map"
      :mapsMode="mapsMode"
      :clickedCoords="clickedCoords"
      @addPoint="$emit('addPoint', $event)"
    ></Generic_LatLong>
  </div>
</template>

<style>

</style>

<script>
import Generic_LatLong from './Generic_LatLong.vue';
export default {
  name: "Generic_Tools",
  props: [
    'measurement',
    'showMeasuringTool',
    'clickedCoords',
    'mapsMode',
    'map',
    'selectedRelease'
  ],
  components: {
    Generic_LatLong
  }
}
</script>